import { createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3916f6d1")

_pushScopeId("data-v-3916f6d1")
const _hoisted_1 = {
  key: 0,
  class: "background"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("span", null, "跳过", -1)
const _hoisted_3 = {
  key: 1,
  class: "in-action-wrapper"
}
const _hoisted_4 = /*#__PURE__*/_createVNode("span", null, "进入瘦吧元宇宙", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_ctx.show)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        (_ctx.skipShow)
          ? (_openBlock(), _createBlock("div", {
              key: 0,
              class: "skip-wrapper",
              onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.clickSkip && _ctx.clickSkip(...args)), ["stop","prevent"]))
            }, [
              _hoisted_2
            ]))
          : _createCommentVNode("", true),
        _createVNode("video", {
          id: _ctx.videoId,
          class: "video-wrapper video-js vjs-default-skin vjs-big-play-centered",
          "webkit-playsinline": "webkit-playsinline",
          playsinline: "playsinline",
          "x5-playsinline": "true",
          "data-setup": "{}",
          poster: _ctx.androidPoster ? _ctx.androidPoster : ''
        }, null, 8, ["id", "poster"]),
        (_ctx.actionShow)
          ? (_openBlock(), _createBlock("div", _hoisted_3, [
              _hoisted_4
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
})